import React, { FC, useEffect } from 'react';
import { Loaders } from 'components';
import { useParams } from 'react-router-dom';
import { useCurrentUser, useNotify } from 'hooks';
import { useCreateLoginTokenForCurrentUserInClientMutation } from 'api';
import * as paths from 'paths';
import { AUTH_DOMAIN } from 'settings';
import { queryString } from 'utilities';

type ConnectParams = { network: string };

const Connect: FC = () => {
  const { network } = useParams<ConnectParams>();
  const currentUser = useCurrentUser();
  const notify = useNotify();
  const { mutate } = useCreateLoginTokenForCurrentUserInClientMutation({
    onError: notify.mutationError,
    onSuccess: ({ createLoginTokenForCurrentUserInClient }) => {
      const params = {
        user_id: currentUser.id,
        token: createLoginTokenForCurrentUserInClient,
        success_callback_url: `${window.location.origin}${paths.connectionSuccess}`,
        failure_callback_url: `${window.location.origin}${paths.connectionFailure}`,
        source: 'web sharing',
      };

      const url = `${AUTH_DOMAIN}/connect/${network}?${queryString(params)}`;
      location.replace(url);
    },
  });
  useEffect(() => {
    mutate({ client_id: currentUser.client_id });
  }, [network]);

  return <Loaders.Standard />;
};

export default Connect;
